export default {
    ADMIN: 'ADMIN',
    DISPATCHER: 'DISPATCHER'
}